import { Component, inject } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import {
  CostPerKilometerWidgetComponent,
  DriverScoreWidgetComponent,
  DriverUtilisationWidgetComponent,
  FuelConsumptionWidgetComponent,
  FuelVarianceWidgetComponent,
  IdleTimeWidgetComponent,
  OvertimeHoursWidgetComponent,
  TripsWidgetComponent,
  ViolationsWidgetComponent
} from './components/graphs/index';
import { DistanceDrivenWidgetComponent } from './components/graphs/distance-driven-widget/distance-driven-widget.component';
import { ExecutiveStatsFilterComponent } from './components/executive-stats-filter/executive-stats-filter.component';
import { DateIntervalFilterData } from '../../_shared/models/filters/widget-filter-data.model';
import { getSelectedFilterLabel } from '../../_shared/helpers/kpiWidget/selected-filter.helper';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

const kpiWidgetsComponents: any[] = [
  CostPerKilometerWidgetComponent,
  FuelConsumptionWidgetComponent,
  FuelVarianceWidgetComponent,
  OvertimeHoursWidgetComponent
]

const widgetsComponents: any[] = [
  ...kpiWidgetsComponents,
  ViolationsWidgetComponent,
  DistanceDrivenWidgetComponent,
  IdleTimeWidgetComponent,
  DriverUtilisationWidgetComponent,
  TripsWidgetComponent,
  DriverScoreWidgetComponent
]

@Component({
  selector: 'app-executive-stats',
  standalone: true,
  imports: [
    NgbTooltipModule,
    ExecutiveStatsFilterComponent,
    TranslocoPipe,
    ...widgetsComponents
],
  templateUrl: './executive-stats.component.html',
  styleUrl: './executive-stats.component.scss',
})
export class ExecutiveStatsComponent {
  private readonly transloco = inject(TranslocoService);
  dateFilter!: DateIntervalFilterData;

  onDateFilterChange(filter: DateIntervalFilterData) {
    this.dateFilter = filter;
  }

  getSelectedFilterLabel(filter: DateIntervalFilterData): string {
    return getSelectedFilterLabel(filter, (key, params) => this.transloco.translate(key, params), this.transloco.getActiveLang());
  }
}